import { render, staticRenderFns } from "./DropdownPanel.vue?vue&type=template&id=20eb75b5&scoped=true&"
import script from "./DropdownPanel.vue?vue&type=script&lang=js&"
export * from "./DropdownPanel.vue?vue&type=script&lang=js&"
import style0 from "./DropdownPanel.vue?vue&type=style&index=0&id=20eb75b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb75b5",
  null
  
)

export default component.exports